import React from 'react';
import usePosts from '../../hooks/usePosts';
import Navbar from '../Shared/Navbar';
import SinglePost from './SinglePost';


const Feed = () => {

    const [posts] = usePosts();

    posts?.sort((a, b) => new Date(b?.date) - new Date(a?.date));

    const availablePosts = posts.filter(post => post.state !== "Finished");

    //console.log(posts);

    return (
        <div className=''>
            <Navbar />
            <div className='w-11/12 lg:w-4/5 mx-auto'>
                {
                    availablePosts?.map(post => (
                        <SinglePost key={post?._id} id={post?._id} />
                    ))
                }
            </div>
        </div>
    );
};

export default Feed;